<template>
    <div class="creatAccount">
        <div class="icon">
            <i class="el-icon-circle-check-outline"></i>
        </div>
        <p>{{$store.state.firstName}}, thanks for signing up. We will notify you when your TVU Search account {{$store.state.email}} is ready to use.</p>
        <div class="btn clearfix">
            <span class="f_l" v-if="backBtn">
                <a @click="back">Back</a>
            </span>
            <el-button class="f_r" @click="link">OK</el-button>
        </div>
    </div>
</template>
<script>
import { gaAnalyze } from '@/assets/js/googleAnalyze/event.js';
export default {
    props:{
        backBtn: Boolean
    },
    data(){
        return{
            activateInfo:{},
            rule:{}
        }
    },
    methods:{
        back(){
            gaAnalyze('lpFailedBack');
            this.$emit('showModule',{type:'back'})
        },
        link(){
            gaAnalyze('lpFailedOK');
            // this.$router.push({name:'home'})
            window.location.href = "https://search.tvunetworks.com/mma/index.html#/index"
        }
    }
}
</script>
<style lang="less" scoped>
h2{
    font-size: .28rem;
    font-weight: normal;
    margin-bottom: 0.17rem;
}
p{
    font-size: .16rem;
    margin-bottom: 0.30rem;
    a{
        color: #1EC345;
    }
}
.icon{
    text-align: center;
    margin-bottom: .30rem;
    font-size: .72rem;
    color: #1EC345;
}
.btn{
    position: relative;
    a{
        color: #1EC345;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
    }
    margin-bottom: .6rem;
}
@media(max-width:1024px){
    h2{
        font-size: .16rem;
        margin-bottom: .1rem;
    }
    p{
        font-size: .12rem;
        margin-bottom: 0.2rem;
    }
}
</style>

